// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__1ZsUM","icon":"styles_icon__1eAVf","nav_bar":"styles_nav_bar__dPVEO","main":"styles_main__3drLS","tips":"styles_tips__3TKr_"};